import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { useAuthUser } from '../../api';
import { useUpdateWorkspace } from '../../api/hooks/workspace/useUpdateWorkspace';

export function QuestionsSettings() {
	const { workspace } = useAuthUser();
	const { mutateAsync: updateWorkspace } = useUpdateWorkspace(workspace.id);

	return (
		<Stack>
			<Box>
				<SettingsSwitch
					onChange={(checked) =>
						updateWorkspace({
							data: { id: workspace.id, questions_enabled: checked },
						})
					}
					checked={workspace?.questions_enabled ?? true}
					title="Questions"
					description="Turn on Questions for this workspace"
				/>
			</Box>
		</Stack>
	);
}
